import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlSegment} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {DOCUMENT} from '@angular/common';
import {Observable, of, switchMap} from 'rxjs';

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService: AuthService = inject(AuthService);
  const document: Document = inject(DOCUMENT);

  const isAuthenticated: Observable<boolean> = authService.isAuthenticated();
  return isAuthenticated.pipe(
    switchMap((isAuthenticated: boolean) => {
      if (!isAuthenticated) {
        const returnUrl: UrlSegment[] = route.url;
        document.location.assign('/Account/Login?returnUrl=' + returnUrl);
      }
      return of(isAuthenticated);
    })
  );
};
